import React from "react";
import {cn} from "../../utils/cn";

/**
 * Empty / error / no-results state. Always: icon → headline → sub → optional CTA.
 */
export default function EmptyState({icon: Icon, title, description, action, tone = "default", className}) {
  const iconBgClass =
    tone === "error" ? "bg-danger-50 text-danger-600" : "bg-brand-50 text-brand-700";

  return (
    <div className={cn("flex flex-col items-center text-center py-12 px-6", className)}>
      {Icon && (
        <div className={cn("h-14 w-14 rounded-full grid place-items-center mb-4", iconBgClass)}>
          <Icon className="h-7 w-7" aria-hidden="true" />
        </div>
      )}
      {title && <h3 className="text-lg font-semibold text-ink-900">{title}</h3>}
      {description && (
        <p className="text-base text-ink-500 mt-1 max-w-sm">{description}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
